import * as React from "react";
import cn from "classnames";

import Styles from "./Grid.module.scss";

interface Props {
  children: React.ReactNode;
  className?: string;
  padded?: boolean;
  halfPadded?: boolean;
  form?: boolean;
  selected?: boolean;
  onClick?: () => void;
  verticalAlign?: boolean;
  name?: string;
}

const BaseRow: React.ForwardRefRenderFunction<HTMLDivElement, Props> = (
  {
    className,
    children,
    halfPadded = false,
    padded = true,
    selected = false,
    verticalAlign = false,
    form = false,
    onClick,
    name,
  }: Props,
  ref
) => {
  const styles = cn(
    Styles["grid-item"],
    {
      [Styles.padded]: padded,
      [Styles.halfPadded]: halfPadded,
      [Styles.selected]: selected,
      [Styles.form]: form,
      [Styles.verticalAlign]: verticalAlign,
    },
    className
  );

  return (
    <div ref={ref} className={styles} onClick={onClick} onKeyDown={onClick} aria-label={name}>
      {children}
    </div>
  );
};

export const GridItem = React.forwardRef(BaseRow);
